import OpenReplay, { App } from '@openreplay/tracker/cjs';
import trackerGraphQL from '@openreplay/tracker-graphql';
import { Messages } from '@openreplay/tracker';
import { Encoder, sha1 } from '@openreplay/tracker-redux/lib/syncod';
import { GetState, SetState, State, StoreApi } from 'zustand';

export const initializeSessionToken = (token?: string | null | undefined) => {
  if (typeof window !== 'undefined') {
    const storedSessionToken = sessionStorage.getItem('sessionToken');

    if (sessionStorage.getItem('sessionTTL')) {
      const storedSessionTTL = new Date(sessionStorage.getItem('sessionTTL') || '');
      if (storedSessionTTL && storedSessionTTL < new Date()) sessionStorage.setItem('sessionToken', token || '');
    }

    const sessionToken = storedSessionToken ? storedSessionToken : token;
    if (!sessionStorage.getItem('sessionToken')) sessionStorage.setItem('sessionToken', sessionToken || '');

    const sessionTTL = new Date();
    sessionTTL.setMinutes(sessionTTL.getMinutes() + 30);
    sessionStorage.setItem('sessionTTL', sessionTTL.toISOString());

    return sessionToken;
  }
  return;
};

export const initializeTracker = ({ projectKey }: { projectKey: string }) => {
  const tracker = new OpenReplay({
    projectKey,
    sessionToken: (typeof window !== 'undefined' ? sessionStorage.getItem('sessionToken') : undefined) as any,
    __DISABLE_SECURE_MODE: process.env.NODE_ENV === 'development'
  });

  return tracker;
};

export const openReplayTracker = initializeTracker({ projectKey: process.env.GATSBY_OPEN_REPLAY_PROJECT || '' });
export const recordGraphQL: any = openReplayTracker.use(trackerGraphQL() as any);
export const openReplayMiddleware: any = openReplayTracker.use(trackerOpenReplay() as any);

export const zustandReplayMiddleware: <
  S extends State,
  CustomSetState extends SetState<S>,
  CustomGetState extends GetState<S>,
  CustomStoreApi extends StoreApi<S>
>(
  fn: (set: CustomSetState, get: CustomGetState, api: CustomStoreApi) => S,
  opts: { name: string }
) => (set: CustomSetState, get: CustomGetState, api: CustomStoreApi) => S =
  (fn, { name }) =>
  (set, get, api) => {
    const initialState = fn(set, get, api);
    api.subscribe((currentState, previousState) => {
      openReplayMiddleware(name, currentState, previousState);
    });

    return initialState;
  };

export function trackerOpenReplay() {
  return (app: App) => {
    if (app === null) {
      return (name: string, currentState: any, previousState: any) => currentState;
    }
    return (name: string, currentState: any, previousState: any) => {
      const encoder = new Encoder(sha1, 50);

      try {
        const _action = encoder.encode({ type: name, payload: previousState });
        const _state = encoder.encode(currentState);
        const _duration = encoder.encode(0);
        const _table: { [x: string]: any } = encoder.commit();
        for (let key in _table) app.send(Messages.OTable(key, _table[key]) as any);
        app.send(Messages.Redux(_action, _state, _duration) as any);
      } catch (_a) {
        encoder.clear();
      }
      return currentState;
    };
  };
}
